import { render, staticRenderFns } from "./PersistDappView.vue?vue&type=template&id=04c226b1&scoped=true"
import script from "./PersistDappView.vue?vue&type=script&lang=ts"
export * from "./PersistDappView.vue?vue&type=script&lang=ts"
import style0 from "./PersistDappView.vue?vue&type=style&index=0&id=04c226b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c226b1",
  null
  
)

export default component.exports